'use client';

import { Container, Stack } from '@mui/material';

import { ServiceTheme } from '@/config/services.config';
import { MainFeature } from '@/types/feature.type';
import useScrollReveal from '@/utils/hooks/useScrollReveal';

import ServiceFeatureCard from './ServiceFeatureCard';
import styles from './ServicesFeaturesSection.module.scss';

interface ServicesFeaturesSectionProps {
  features: MainFeature[];
  theme: ServiceTheme;
}

const ServicesFeaturesSection = ({ features, theme }: ServicesFeaturesSectionProps) => {
  const { setRef, isVisible } = useScrollReveal<HTMLDivElement>(features.length);

  return (
    <Container component="section" maxWidth="xl" classes={{ root: styles.root }} className={styles.container}>
      <Stack className={styles.wrapper}>
        {features.map((feature, index) => (
          <ServiceFeatureCard
            key={feature.title}
            ref={setRef(index)}
            visible={isVisible(index)}
            reverse={index % 2 !== 0}
            theme={theme}
            {...feature}
          />
        ))}
      </Stack>
    </Container>
  );
};

export default ServicesFeaturesSection;
